
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, class_type, anonRecord_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../Shared/Storage.js";
import { FormState__getValidation, FormState__startLoading, StorageId__get_unwrap, BusinessUnitId__get_unwrap, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, RequestedValue$1, FormState_get_empty, TokenDataDto_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ToolTypes_$reflection } from "../../Shared/Tool.js";
import { MultiBusinessUnitUpdateDto, MultiBusinessUnitUpdateDto_$reflection } from "../../Shared/MultiOperation.js";
import { length, toArray as toArray_1, tryPick, tryFind, choose, collect, find, append as append_1, contains, filter, ofArray, singleton as singleton_1, map, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { getBusinessUnits } from "../../Requests/BusinessUnit.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createObj, equals, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { FSharpMap__get_IsEmpty, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Table/Table.js";
import { TabsMenu } from "../TabsMenu.js";
import { Select } from "../../Components/Select.js";
import { BusinessUnitSelect } from "../BusinessUnitSelect.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiChangeBusinessUnitModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quantity, Type, Unit, BusinessUnit, StorageSpace, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quantity = Quantity;
        this.Type = Type;
        this.Unit = Unit;
        this.BusinessUnit = BusinessUnit;
        this.StorageSpace = StorageSpace;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiChangeBusinessUnitModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quantity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["BusinessUnit", string_type], ["StorageSpace", string_type], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Save", "SetBusinessUnit", "SetSelectedStorage", "AddElement", "RemoveElement", "InitTableElements", "UpdateStorageOptions", "BusinessUnitResponse", "SetsFetched", "ToolsFetched", "StoragesFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiChangeBusinessUnitModal.Msg", [], Msg, () => [[], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["ids", list_type(string_type)]], [["ids", list_type(string_type)]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Sets, Tools, BusinessUnits, TableElements, RemovedElements, Dto, CurrentStorage, StorageOptions, Storages, UserData) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Tools = Tools;
        this.BusinessUnits = BusinessUnits;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.CurrentStorage = CurrentStorage;
        this.StorageOptions = StorageOptions;
        this.Storages = Storages;
        this.UserData = UserData;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiChangeBusinessUnitModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiBusinessUnitUpdateDto_$reflection()], ["CurrentStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["StorageOptions", list_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["UserData", TokenDataDto_$reflection()]]);
}

function init(successCallback, onClose, userData, toolProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, isEmpty(toolProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(toolProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), new RequestedValue$1(0, []), empty(), empty(), new MultiBusinessUnitUpdateDto(empty(), empty(), undefined, ""), undefined, empty(), new RequestedValue$1(0, []), userData), Cmd_batch(toList(delay(() => append(!isEmpty(toolProps.SetIds) ? singleton(getSelectedSets(toolProps.SetIds, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(12, [Item_1])))) : empty_1(), delay(() => append(!isEmpty(toolProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, toolProps.ToolIds), (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(12, [Item_3])))) : empty_1(), delay(() => append(singleton(getBusinessUnits((Item_4) => (new Msg(11, [Item_4])), (Item_5) => (new Msg(12, [Item_5])))), delay(() => singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_6) => (new Msg(10, [Item_6])), (Item_7) => (new Msg(12, [Item_7])))))))))))))];
}

function update(msg, state) {
    let bind$0040_1;
    switch (msg.tag) {
        case 7: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultiBusinessUnitUpdateDto(bind$0040_1.SetIds, bind$0040_1.ToolIds, map_1((_arg_2) => _arg_2.value.Id, msg.fields[0]), bind$0040_1.StorageId)), state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), singleton_1((dispatch) => {
                dispatch(new Msg(6, []));
            })];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.StorageOptions, state.Storages, state.UserData), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(6, []));
            })];
        case 3: {
            const addedElements = msg.fields[0];
            const selectedElement = filter((tableElement) => contains(tableElement.Id, addedElements, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }), state.RemovedElements);
            const updatedRemovedElements = filter((tableElement_1) => !contains(tableElement_1.Id, addedElements, {
                Equals: (x_2, y_1) => (x_2 === y_1),
                GetHashCode: (x_2) => (stringHash(x_2) | 0),
            }), state.RemovedElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, append_1(selectedElement, state.TableElements), updatedRemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_none()];
        }
        case 4: {
            const removedElements = msg.fields[0];
            const selectedElement_1 = filter((tableElement_2) => contains(tableElement_2.Id, removedElements, {
                Equals: (x_3, y_2) => (x_3 === y_2),
                GetHashCode: (x_3) => (stringHash(x_3) | 0),
            }), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, filter((tableElement_3) => !contains(tableElement_3.Id, removedElements, {
                Equals: (x_4, y_3) => (x_4 === y_3),
                GetHashCode: (x_4) => (stringHash(x_4) | 0),
            }), state.TableElements), append_1(selectedElement_1, state.RemovedElements), state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_none()];
        }
        case 8:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(5, []));
            })];
        case 9:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), singleton_1((dispatch_3) => {
                dispatch_3(new Msg(5, []));
            })];
        case 11:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), singleton_1((dispatch_4) => {
                dispatch_4(new Msg(5, []));
            })];
        case 10:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, new RequestedValue$1(1, [msg.fields[0]]), state.UserData), singleton_1((dispatch_5) => {
                dispatch_5(new Msg(5, []));
            })];
        case 5: {
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            const matchValue_3 = state.BusinessUnits;
            let matchResult, businessUnits, sets, tools;
            if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_3.tag === 0) {
                matchResult = 1;
            }
            else if (state.Storages.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                businessUnits = matchValue_3.fields[0];
                sets = matchValue_2.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const setElements = map((set$) => {
                        let matchValue_6, businessUnitId;
                        return new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, undefined, new TableElementType(3, []), "piece", (matchValue_6 = set$.BusinessUnitId, (matchValue_6 != null) ? ((businessUnitId = matchValue_6, find((businessUnit) => (businessUnit.Id === businessUnitId), businessUnits).Name)) : ""), set$.LocationInformation.StorageSpace, empty());
                    }, sets);
                    const setAssignedToolIds = collect((x_5) => x_5, map((set$_1) => map((_arg_3) => _arg_3.ToolId, set$_1.AssignedTools), sets));
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, append_1(setElements, choose((tool) => {
                        let matchValue_7, businessUnitId_1;
                        if (tool.tag === 1) {
                            return undefined;
                        }
                        else {
                            const tool_1 = tool.fields[0];
                            if (contains(ToolId__get_unwrap(tool_1.Id), setAssignedToolIds, {
                                Equals: (x_6, y_4) => (x_6 === y_4),
                                GetHashCode: (x_6) => (stringHash(x_6) | 0),
                            })) {
                                return undefined;
                            }
                            else {
                                return new TableElement(newGuid(), ToolId__get_unwrap(tool_1.Id), tool_1.Manufacturer, tool_1.Model, tool_1.DisplayName, "", tool_1.InventoryNumber, undefined, new TableElementType(0, []), "piece", (matchValue_7 = tool_1.BusinessUnitId, (matchValue_7 != null) ? ((businessUnitId_1 = matchValue_7, find((businessUnit_1) => (businessUnit_1.Id === BusinessUnitId__get_unwrap(businessUnitId_1)), businessUnits).Name)) : ""), tool_1.StorageSpace, empty());
                            }
                        }
                    }, tools)), state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_none()];
                }
                default:
                    return [state, singleton_1((dispatch_6) => {
                        dispatch_6(new Msg(6, []));
                    })];
            }
        }
        case 6: {
            const matchValue_8 = state.Storages;
            if (matchValue_8.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const updatedOptions = filter((storage_1) => {
                    const matchValue_9 = storage_1.value.BusinessUnitId;
                    const matchValue_10 = state.Dto.BusinessUnitId;
                    if (matchValue_9 == null) {
                        if (matchValue_10 != null) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    else if (matchValue_10 == null) {
                        return false;
                    }
                    else {
                        const businessUnitId_2 = matchValue_10;
                        const storageBusinessUnitId = matchValue_9;
                        return BusinessUnitId__get_unwrap(storageBusinessUnitId) === businessUnitId_2;
                    }
                }, map((storage) => ({
                    label: Storage__get_DisplayName(storage),
                    value: storage,
                }), matchValue_8.fields[0]));
                return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, tryFind((option_1) => {
                    const matchValue_12 = state.CurrentStorage;
                    if (matchValue_12 == null) {
                        return false;
                    }
                    else {
                        return equals(matchValue_12.value.Id, option_1.value.Id);
                    }
                }, updatedOptions), filter((storage_3) => {
                    const matchValue_13 = state.CurrentStorage;
                    if (matchValue_13 == null) {
                        return true;
                    }
                    else {
                        const currentStorage_1 = matchValue_13;
                        return StorageId__get_unwrap(storage_3.value.Id) !== StorageId__get_unwrap(currentStorage_1.value.Id);
                    }
                }, updatedOptions), state.Storages, state.UserData), Cmd_none()];
            }
        }
        case 12:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_errorToast("general.a_error_occured")];
        default: {
            const matchValue = state.CurrentStorage;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const currentStorage = matchValue;
                const updatedDto = new MultiBusinessUnitUpdateDto(map((element_1) => element_1.ElementId, filter((element) => equals(element.Type, new TableElementType(3, [])), state.TableElements)), map((element_3) => element_3.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(0, [])), state.TableElements)), state.Dto.BusinessUnitId, StorageId__get_unwrap(currentStorage.value.Id));
                return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.BusinessUnits, state.TableElements, state.RemovedElements, state.Dto, state.CurrentStorage, state.StorageOptions, state.Storages, state.UserData), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix_1(tupledArg[0]), (refreshOn) => fetchWithDecoder_1(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/multi-operations/business-unit", toString(0, Auto_generateBoxedEncoder_437914C6(MultiBusinessUnitUpdateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(12, [Item_1])))];
            }
        }
    }
}

function elementValidation(translate, formState, elementId) {
    return tryPick((tupledArg) => {
        if (tupledArg[0].startsWith(concat(elementId, ..."-"))) {
            return translate(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, toList_1(formState.Validations));
}

function Table(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = elementValidation(t, props.FormState, row.ElementId);
        if (matchValue == null) {
            return new CellContent(0, [""]);
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_3) => (new CellContent(0, [row_3.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("businessUnit", "", t("business_units.business_unit"), (row_5) => (new CellContent(0, [row_5.BusinessUnit])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_6) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_6.Unit))])), "none", "text"))))))))))))))));
    const elementTable = (tableKey, rows, onSelected) => {
        let elems, TableRows, Options;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(rows), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "multiRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columnDefinition,
            Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                props.Dispatch(onSelected(map((_arg) => _arg.Id, rows_1)));
            }), true, false, "tools-dialog-toolreservation-dialog-remove-button")])),
            Options: Options,
            TableKey: tableKey,
            TableRows: TableRows,
        })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "flex-1"])], (elems_2 = toList(delay(() => {
        let elems_1, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: (arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, patternInput[1].t("assign_multiple_tools_dialog.removed_elements", arg_1)),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (props.IsAddedElementTabVisible ? singleton(elementTable("multi-change-business-unit-elements", props.TableElements, (ids) => (new Msg(4, [ids])))) : singleton(elementTable("multi-change-business-unit-removed-elements", props.RemovedElements, (ids_1) => (new Msg(3, [ids_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StorageSelect(props) {
    const t = useTranslation()[0];
    return createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        Label: t("general.storage"),
        NoOptionsMessage: "",
        OnChange: (option) => {
            props.Dispatch(new Msg(2, [option]));
        },
        Options: props.StorageOptions,
        PlaceholderKey: "",
        TestId: "business-unit-change-dialog-storage-test-id",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
        Value: unwrap(props.SelectedStorage),
    });
}

function Form(props) {
    let elems_2, elems, elems_1, Label;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_2 = [reactElement("div", createObj(ofArray([["id", "change-multiple-business-unit-dialog-body"], ["data-test-id", "change-multiple-business-unit-dialog-body"], ["className", join(" ", ["grid", "gap-5"])], (elems = toList(delay(() => append(singleton(createElement(BusinessUnitSelect, {
        BusinessUnits: props.BusinessUnits,
        FormState: props.FormState,
        OnChange: (value_6) => {
            props.Dispatch(new Msg(1, [value_6]));
        },
        SelectedBusinessUnitId: unwrap(props.Dto.BusinessUnitId),
    })), delay(() => append(singleton(createElement(StorageSelect, {
        ComponentState: componentState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        SelectedStorage: unwrap(props.SelectedStorage),
        StorageOptions: props.StorageOptions,
    })), delay(() => {
        const matchValue = FormState__getValidation(props.FormState, t, "global");
        if (matchValue == null) {
            return empty_1();
        }
        else {
            return singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }));
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_1 = [createElement(Button, (Label = t("general.save"), {
        ComponentState: (componentState === "disabled") ? "disabled" : ((props.IsTableElementsEmpty ? true : (props.SelectedStorage == null)) ? "disabled" : "enabled"),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "multiple-business-unit-save-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "flex-1"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isAddedElementsTabSelected ? singleton(createElement(Form, {
            BusinessUnits: props.BusinessUnits,
            Dispatch: props.Dispatch,
            Dto: props.Dto,
            FormState: props.FormState,
            IsTableElementsEmpty: isEmpty(props.TableElements),
            SelectedStorage: unwrap(props.SelectedStorage),
            StorageOptions: props.StorageOptions,
        })) : empty_1())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiChangeBusinessUnitModalSheet(props) {
    let elems, matchValue_2;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.ToolProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue_2 = state_1.BusinessUnits, (state_1.Sets.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((state_1.Tools.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((state_1.Storages.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            BusinessUnits: matchValue_2.fields[0],
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            RemovedElements: state_1.RemovedElements,
            SelectedStorage: unwrap(state_1.CurrentStorage),
            StorageOptions: state_1.StorageOptions,
            TableElements: state_1.TableElements,
        }))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("multi_operation.change_business_unit.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

